module.exports = __webpack_public_path__ + "static/media/vkIcon.4619a5a0.svg";